import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { emit } from '@/lib/events';
import type { ProfilePresetId } from './profilePresets';
import type { ProfileWeights } from './scoreComune';
import { PROFILE_PRESETS_BY_ID } from './profilePresets';

interface ScoringState {
  activePresetId: ProfilePresetId;
  customWeights: ProfileWeights | null;  // null = use preset weights
  setPreset: (id: ProfilePresetId) => void;
  setCustomWeights: (w: ProfileWeights) => void;
  resetToPreset: () => void;
}

export const useScoringStore = create<ScoringState>()(
  persist(
    (set, _get) => ({
      activePresetId: 'balanced',
      customWeights: null,

      setPreset: (id) => {
        set({ activePresetId: id, customWeights: null });
        emit('scoring:preset_changed', { preset_id: id });
      },

      setCustomWeights: (w) => set({ customWeights: w }),

      resetToPreset: () => set({ customWeights: null }),
    }),
    {
      name: 'relocation_scoring_v1',
      storage: createJSONStorage(() => localStorage),
      partialize: (s) => ({
        activePresetId: s.activePresetId,
        customWeights: s.customWeights,
      }),
    },
  ),
);

/** Returns the effective weights (custom if set, otherwise active preset's). */
export function getEffectiveWeights(state: ScoringState): ProfileWeights {
  if (state.customWeights) return state.customWeights;
  return PROFILE_PRESETS_BY_ID[state.activePresetId].weights;
}

export function useEffectiveWeights(): ProfileWeights {
  return useScoringStore((s) => getEffectiveWeights(s));
}
